import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7jgns9vu20: FaireBrandEntity = {
  token: "b_7jgns9vu20",
  type: "brand",
  name: "Abba Christian Products",
  avatarUrl:
    "https://cdn.faire.com/fastly/f0e3d0b227cf3f73d3372d7c5dc842610343b06ff4e090d90a27bbbcf27149dc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6ca031c3c1947b6c0950436f0756e79162d649b239500fe1ecb39b269ede5088.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f0e3d0b227cf3f73d3372d7c5dc842610343b06ff4e090d90a27bbbcf27149dc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6ca031c3c1947b6c0950436f0756e79162d649b239500fe1ecb39b269ede5088.png",
  location: "houston, TX, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 72,
  isTopShop: true,
  isInsider: true,
  description:
    "OUR MISSION is to provide Biblical fragrant anointing oils to be used as “ministry tools”. Our mandate from the Lord was and is to use the finest olive oil from Israel and the purest resins, gums, spices and herbs available in the production of our anointing oils. Our commitment is to serve and undergird ministries and individuals throughout the world who use anointing oil in worship and in prayer for healing, deliverance, consecration, and dedication. Wherever possible, scriptures and prayers are provided with each product to encourage and instruct the user.\n\nOUR PRODUCTS\nAbba strives for excellence in everything we do and our products are designed to bring honor to the King of Kings, whether used personally or given as gifts. As these fragrant oils and candles are used in prayer for healing, cleansing, deliverance, dedication and consecration and during times of worship and intercession, many will experience a deep awareness of His presence. The eco-friendly soy wax and palm wax used in the making of the candles is blended with the same fragrant oils that are used in our anointing oils. Even before the candles are lit, they give off a wonderful fragrance that fills the room. Designed to last a long time, they bring hours of enjoyment to the user. Our bath and spa products, are made with the finest aromatherapeutic ingredients using the same wonderful fragrant oils found in our anointing oils and candles.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:50.404Z",
    importedBy: "entity-db-cli",
  },
};
